var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestartVideoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -7,
    y: -7,
    width: 114,
    height: 114
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3.5px)",
      clipPath: "url(#bgblur_0_7554_8449_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 7,
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#0A0A0B",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3333 29.6667V18L35.75 32.5833L50.3333 47.1667V35.5C59.9875 35.5 67.8333 43.3458 67.8333 53C67.8333 62.6542 59.9875 70.5 50.3333 70.5C40.6792 70.5 32.8333 62.6542 32.8333 53H27C27 65.8917 37.4417 76.3333 50.3333 76.3333C63.225 76.3333 73.6667 65.8917 73.6667 53C73.6667 40.1083 63.225 29.6667 50.3333 29.6667Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_7554_8449_clip_path",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestartVideoIcon);
export default __webpack_public_path__ + "static/media/restartVideoIcon.49a8ecf1b9d4b3e61e1696b28904679e.svg";
export { ForwardRef as ReactComponent };